// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import {
    ActivityAnswersTitleWrapper,
    ActivityAnswersIcon,
    ActivityAnswersTitle,
    AnswerItemCompositionsWrapper,
    ActivityAnswerItemContainer,
    ActivityAnswerItemTextContentWrapper,
    ActivityAnswerItemIndicatorWrapper,
    ActivityAnswerItemIndicator,
    ActivityAnswerItemLabel,
    ActivityAnswersContainer
} from "./activity-answers.styles";

// Types
import { ActivityAnswerItemProps, ActivityAnswerItemVariant, ActivityAnswersProps } from "./activity-answers.types";

// Utils
import { ternary } from "utils/ternary";
import { theme } from "config/theme";

export const ActivityAnswers: FunctionComponent<ActivityAnswersProps> = ({ icon, title, answerItemCompositions }) => {
    return (
        <ActivityAnswersContainer>
            <ActivityAnswersTitleWrapper>
                <ActivityAnswersIcon src={icon} />

                <ActivityAnswersTitle>{title}</ActivityAnswersTitle>
            </ActivityAnswersTitleWrapper>

            <AnswerItemCompositionsWrapper>{answerItemCompositions}</AnswerItemCompositionsWrapper>
        </ActivityAnswersContainer>
    );
};

export const ActivityAnswerItem: FunctionComponent<ActivityAnswerItemProps> = ({
    variant = "default",
    indicator,
    label,
    actionButtonComposition
}) => {
    const backgroundColor = ternary([
        [variant === "default", theme.colors.base[200]],
        [variant === "danger", theme.colors.system.danger[200]],
        [variant === "success", theme.colors.system.success[200]]
    ]) as ActivityAnswerItemVariant;

    const color = ternary([
        [variant === "default", theme.colors.base[400]],
        [variant === "danger", theme.colors.base[500]],
        [variant === "success", theme.colors.base[500]]
    ]) as ActivityAnswerItemVariant;

    return (
        <ActivityAnswerItemContainer className="webapp-activity-answer-item">
            <ActivityAnswerItemTextContentWrapper>
                <ActivityAnswerItemIndicatorWrapper backgroundColor={backgroundColor}>
                    <ActivityAnswerItemIndicator color={color}>{indicator}</ActivityAnswerItemIndicator>
                </ActivityAnswerItemIndicatorWrapper>

                <ActivityAnswerItemLabel>{label}</ActivityAnswerItemLabel>
            </ActivityAnswerItemTextContentWrapper>

            {actionButtonComposition}
        </ActivityAnswerItemContainer>
    );
};
